<span class="badge badge-cliente-analise-mercado-status-projetado-badge badge-cliente-analise-mercado-status-projetado-badge-nao-projetado"
    [title]="getTitle()">
    {{status.nome}}    
</span>